<template>
<div class="k-page-content">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="用户组管理" name="first">
                <div class="k-page-common">
                    <div class="k-common-header">
                        <div class="k-filter-option k-filter-input" style="margin-bottom:0;">
                            <el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
                                <el-form-item label="用户组名称">
                                    <el-input v-model="searchForm.group_name" placeholder="请填写用户组名称"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="doSearch">查询</el-button>
                                    <el-button type="primary" @click="reset">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="k-table-toolbar" style="margin-top:0;">
                                <div>
                                    <el-button v-if="$parent.$parent.isAuthAction('admin/fyauth/fyauth/ctGroup')" type="primary" size="mini" @click="addGroupOpen()">添加用户组</el-button>
                                </div>
                            </div>
                            <div class="k-table-con">
                                <el-table
                                    :data="tableData.data"
                                    style="width: 100%"
                                    border
                                    stripe
                                    ref="table"
                                    highlight-current-row
                                    @sort-change="sortChange"
                                    :height="tableHeight">
								<el-table-column
									prop="company_name"
									label="所属公司"
									min-width="200">
                                </el-table-column>
                                <el-table-column
                                        fixed
                                        prop="group_name"
                                        label="用户组名称"
                                        min-width="150">
                                </el-table-column>
                                <el-table-column
                                        prop="create_time"
                                        label="创建时间"
                                        min-width="150"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        prop="update_time"
                                        label="修改时间"
                                        min-width="150"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        fixed="right"
                                        label="操作"
                                        width="200">
                                    <template slot-scope="scope">
                                        <el-button @click="handleTableMenusOpen(scope.row)" type="text" size="small" v-if="$parent.$parent.isAuthAction('admin/fyauth/fyauth/ctGMA')">菜单</el-button>
                                        <el-button @click="handleTableActionsOpen(scope.row)" type="text" size="small" v-if="$parent.$parent.isAuthAction('admin/fyauth/fyauth/ctGMA')">功能</el-button>
                                        <el-button @click="handleTableEditOpen(scope.row)" type="text" size="small" v-if="$parent.$parent.isAuthAction('admin/fyauth/fyauth/editGroup')">编辑</el-button>
                                        <el-button @click="handleTableDelete(scope.row)" type="text" size="small" class="c-danger" v-if="$parent.$parent.isAuthAction('admin/fyauth/fyauth/delGroup')">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                            	background
                            	ref="pagination"
								@size-change="handleSizeChange"
                            	@current-change="handleCurrentChange"
                            	:current-page="tableData.page | number"
                            	:page-size="tableData.pagesize | number"
								:page-sizes="[15, 30, 50, 100]"
                            	layout="prev, pager, next, sizes, total"
                            	:total="tableData.total | number">
                            </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    <!--添加用户组-->
    <el-dialog
      title="添加用户组"
	   v-loading="loading"
      :visible.sync="addFormVisiable"
	  :close-on-click-modal="false"
      width="40%">
    	  <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px">
    		  <div>
    			  <el-form-item label="用户组名称" prop="group_name">
    				<el-input v-model="addForm.group_name" placeholder="请填写用户组名称" clearable></el-input>
    			  </el-form-item>
				  <el-form-item label="所属公司" prop="company_id">
    				<el-select v-model="addForm.company_id" placeholder="请选择所属公司">
						<el-option
						v-for="item in options.company_options"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
    			  </el-form-item>
    		  </div>
    	  </el-form>
    	  <span slot="footer" class="dialog-footer">
    		<el-button type="primary" @click="addGroup" :size='size'>提交</el-button>
    		<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
    	  </span>
    </el-dialog>
    <!--编辑部门-->
    <el-dialog
      title="编辑用户组"
	   v-loading="loading"
      :visible.sync="editFormVisiable"
	  :close-on-click-modal="false"
      width="40%">
    	  <el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px">
    		  <div>
    			<el-form-item label="用户组名称" prop="group_name">
    				<el-input v-model="editForm.group_name" placeholder="请填写用户组名称" clearable></el-input>
    			</el-form-item>
				<el-form-item label="所属公司" prop="company_id">
    				<el-select v-model="editForm.company_id" placeholder="请选择所属公司">
						<el-option
						v-for="item in options.company_options"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
    			  </el-form-item>
    		  </div>
    	  </el-form>
    	  <span slot="footer" class="dialog-footer">
    		<el-button type="primary" @click="handleTableEdit" :size='size'>提交</el-button>
    		<el-button :size='size' @click="editFormVisiable = false">取消</el-button>
    	  </span>
    </el-dialog>
    
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="menusFormVisiable"
		:wrapperClosable="false"
		:close-on-press-escape="false"
        direction="rtl"
        size="70%">
        <el-form :model="menusForm" :size="size" label-width="80px" v-loading="loading">
            <div class="drawer-header">
                <div class="header-title">
                    <span>为用户组分配菜单权限</span>
                    <i class="el-icon-close k-drawer-close" @click="menusFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
                <el-main :style="apiMainHeight">
					<el-tree
					  :data="options.menus"
					  show-checkbox
					  node-key="id"
					  ref='menuTree'
					  :default-checked-keys='menusForm.privileges'
					  default-expand-all
					  :props="defaultPropsMenu">
					</el-tree>
                </el-main>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="handleTableMenus" :size='size'>提交</el-button>
                <el-button :size='size' @click="menusFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>

    <el-drawer
        custom-class="k-drawer"
        :visible.sync="actionsFormVisiable"
		:wrapperClosable="false"
		:close-on-press-escape="false"
        direction="rtl"
        size="70%">
        <el-form :model="actionsForm" :size="size" label-width="80px" v-loading="loading">
            <div class="drawer-header">
                <div class="header-title">
                    <span>为用户组分配功能权限</span>
                    <i class="el-icon-close k-drawer-close" @click="actionsFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
                <el-main :style="apiMainHeight">
					<el-tree
					  :data="options.actions"
					  show-checkbox
					  node-key="id"
					  ref='actionTree'
					  :default-checked-keys='actionsForm.privileges'
					  default-expand-all
					  :props="defaultPropsAction">
					</el-tree>
                </el-main>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="handleTableActions" :size='size'>提交</el-button>
                <el-button :size='size' @click="actionsFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
    
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
		  loading:false,
          actionsFormVisiable: false,
          menusFormVisiable: false,
          addFormVisiable: false,
          editFormVisiable: false,
          checkSkVisiable: false,
          activeName: 'first',
          size:'mini',
          options: {
              menus: [],
              actions: [],
			  company_options: []
          },
          searchForm: {
              type: 'name',
              name: '',
              level: '',
          },
          resetSearch: {
              type: 'name',
              name: '',
              level: '',
          },
          addForm: {
              name: '',
              level: 'LEVEL_ONE',
              status: 'STATUS_NORMAL',
          },
          editForm: {
              name: '',
              level: 'LEVEL_ONE',
              status: 'STATUS_NORMAL',
          },
          menusForm: {
              id: '',
              privileges: []
          },
          actionsForm: {
              id: '',
              privileges: []
          },
          checkSkForm: {
              id: '',
              secret_key: ''
          },
          checkSk: {
              show: false,
              text: '显示',
          },
		  defaultPropsMenu: {
			children: 'children',
			label: 'menu_name'
		  },
		  defaultPropsAction: {
			children: 'children',
			label: 'action_name'
		  },
          rules: {
              addForm: {
                  'group_name': [
                      {required: true, message: '请填写正确的用户组名称，长度不超过 50', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的用户组名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
				  'company_id': [
                      {required: true, message: '请选择所属公司', trigger: ['change']},
                  ]
              },
              editForm: {
                  'group_name': [
                      {required: true, message: '请填写正确的用户组名称，长度不超过 50', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的用户组名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
				  'company_id': [
                      {required: true, message: '请选择所属公司', trigger: ['change']},
                  ]
              }
          },
          tableData: {
              total: 0,
              pagesize: 15,
              page: 1,
              data: []
          }
      }
  },
  computed: {
      tableHeight: function () {
          return window.innerHeight - 320;
      },
      apiMainHeight: function () {
          var height = window.innerHeight - 180;
          return {height: height + 'px', border: '1px solid #DCDFE6', 'margin-bottom': '10px'}
      },
  },
  mounted: function () {
		this.handleSearch(this.searchForm);
  },
  methods: {
		handleSizeChange(pages){
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		//获取所属公司
		getCompanyOption(){
			this.$api.get('/admin/customers/customer/getCompanySelect',{}).then(res => {
				if (res.code === 0) {
				  this.options.company_options = res.data;
				} else {
				  this.$message.error(res.msg);
				}
			})
		},
		handleSearch: function (params, page, prop, order) {
		  this.loading = true;
		  var param = Object.assign({}, params);
		  param['page'] = page ? page : this.tableData.page;
		  param['pagesize'] = this.tableData.pagesize;
		  param['prop'] = prop ? prop : 'id';
		  param['order'] = order ? order : 'desc';
		  this.$api.get('/admin/fyauth/fyauth/grouplist',param).then(res => {
			  if (res.code === 0) {
				  this.tableData = res.data;
			  } else {
				  this.$message.error(res.msg);
			  }
			  this.loading = false
		  })
		},
		// 执行查询
		doSearch() {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset() {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange(e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
			  order = 'asc';
			} else if (e.order == 'descending') {
			  order = 'desc';
			} else {
			  prop = this.resetSearch.prop;
			  order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange(val) {
			this.handleSearch(this.searchForm, val);
		},
		// 添加用户组弹窗
		addGroupOpen(){
			this.addForm = {
				group_name: '',
				company_id: '',
			}
			this.getCompanyOption()
		    this.addFormVisiable = true;
		},
		// 添加用户组
		addGroup() {
		  this.$refs['addForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.post('/admin/fyauth/fyauth/ctGroup',this.addForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '添加用户组成功！',
							  type: 'success'
						  });
						  this.addFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
		
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
		  }.bind(this));
		},
		// 打开编辑用户组弹窗
		handleTableEditOpen(row) {
			this.$api.get('/admin/fyauth/fyauth/groupInfo',{id:row.id}).then(res => {
				  if (res.code === 0) {
					  this.editForm = res.data
					  this.getCompanyOption()
					  this.editFormVisiable = true;
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			})
		},
		// 编辑用户组
		handleTableEdit() {
		  this.$refs['editForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.put('/admin/fyauth/fyauth/editGroup',this.editForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '用户组信息修改成功！',
							  type: 'success'
						  });
						  this.editFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
		  }.bind(this));
		},
		// 删除用户组
		handleTableDelete(row) {
		  this.$confirm('此操作将永久删除该用户组, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
		  }).then(function() {
			  this.loading = true;
			  this.$api.delete('/admin/fyauth/fyauth/delGroup', {id:row.id}).then(res => {
				  if (res.code === 0) {
					  var data = this.tableData.data;
					  data.forEach(function (item, index) {
						  if (item.id == row.id) {
							  this.$delete(data, index);
						  } else if (item.children) {
							  item.children.forEach(function (value, key) {
								  if (value.id == row.id) {
									  this.$delete(item.children, key);
								  }
							  }.bind(this));
							  this.handleSearch(this.searchForm);
						  }
					  }.bind(this));
					  this.$message({
						  showClose: true,
						  message: '该部门已成功删除！',
						  type: 'success'
					  });
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			  })
		  }.bind(this))
		},
		handleTableMenusOpen(row){
			this.loading = true;
			this.$api.get('/admin/fyauth/fyauth/getGML', {group_id:row.id}).then(res => {
			  if (res.code === 0) {
				  this.options.menus = res.data.menus;
				  this.menusForm.privileges = res.data.privileges;
				  this.menusForm.id = row.id;
				
				  this.$message({
					  showClose: true,
					  message: '查询用户组信息成功！',
					  type: 'success'
				  });
				  this.menusFormVisiable = true;
			  } else {
				  this.$message.error(res.msg);
			  }
			  this.loading = false
			})
		},
		// 全选
		handleTableSlectAll: function (form) {
		  switch (form) {
			  case 'menusForm':
				  var privileges = [];
				  var item;
				  for (var i in this.options.menus) {
					  item = this.options.menus[i];
					  for (var index in item.children) {
						  privileges.push(item.children[index].id);
					  }
				  }
				  this.menusForm.privileges = privileges;
				  break;
			  case 'actionsForm':
				  var privileges = [];
				  var item;
				  for (var i in this.options.actions) {
					  item = this.options.actions[i];
					  for (var index in item.children) {
						  privileges.push(item.children[index].id);
					  }
				  }
				  this.actionsForm.privileges = privileges;
				  break;
		  }
		},

		// 反选
		handleTableSelectChange: function (form) {
		  switch (form) {
			  case 'menusForm':
				  var privileges = [];
				  var item;
				  for (var i in this.options.menus) {
					  item = this.options.menus[i];
					  for (var index in item.children) {
						  if (this.menusForm.privileges.indexOf(item.children[index].id) < 0) {
							  privileges.push(item.children[index].id);
						  }
					  }
				  }
				  this.menusForm.privileges = privileges;
				  break;
			  case 'actionsForm':
				  var privileges = [];
				  var item;
				  for (var i in this.options.actions) {
					  item = this.options.actions[i];
					  for (var index in item.children) {
						  if (this.actionsForm.privileges.indexOf(item.children[index].id) < 0) {
							  privileges.push(item.children[index].id);
						  }
					  }
				  }
				  this.actionsForm.privileges = privileges;
				  break;
		  }
		},
		// 全不选
		handleTableCancelAll: function (form) {
		  switch (form) {
			  case 'menusForm':
				  this.menusForm.privileges = [];
				  break;
			  case 'actionsForm':
				  this.actionsForm.privileges = [];
				  break;
		  }
		},
		//用户组关联菜单
		handleTableMenus(){
			this.loading = true;
			const checkedNodes = this.$refs.menuTree.getCheckedKeys()
			let newMenusForm = {
				group_id:this.menusForm.id,
				association_type:'MENU',
				association_id:checkedNodes
			}
			this.$api.post('/admin/fyauth/fyauth/ctGMA', newMenusForm).then(res => {
			  if (res.code === 0) {
				  this.$message({
					  showClose: true,
					  message: '用户组关联菜单权限成功！',
					  type: 'success'
				  });
				  this.menusFormVisiable = false;
			  } else {
				  this.$message.error(res.msg);
			  }
			  this.loading = false
			})
		},
		// 打开用户组功能弹窗
		handleTableActionsOpen: function (row) {
		    this.loading = true;
		    this.$api.get('/admin/fyauth/fyauth/getGAL', {group_id:row.id}).then(res => {
		      if (res.code === 0) {
		    	  this.options.actions = res.data.actions;
		    	  this.actionsForm.privileges = res.data.privileges;
		    	  this.actionsForm.id = row.id;
		    	
		    	  this.$message({
		    		  showClose: true,
		    		  message: '查询用户组信息成功！',
		    		  type: 'success'
		    	  });
		    	  this.actionsFormVisiable = true;
		      } else {
		    	  this.$message.error(res.msg);
		      }
		      this.loading = false
		    })
		},
		//用户组关联功能
		handleTableActions: function () {
		    this.loading = true;
			const checkedNodes = this.$refs.actionTree.getCheckedKeys()
			let newActionsForm = {
				group_id:this.actionsForm.id,
				association_type:'ACTION',
				association_id:checkedNodes
			}
			this.$api.post('/admin/fyauth/fyauth/ctGMA', newActionsForm).then(res => {
				if (res.code === 0) {
					  this.$message({
						  showClose: true,
						  message: '用户组关联功能权限成功！',
						  type: 'success'
					  });
					  this.actionsFormVisiable = false;
				} else {
					  this.$message.error(res.msg);
				}
				this.loading = false
			})
		  
		},
  }
}
</script>